import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import * as actions from "./actiontypes";
import employeeRecordApi from "./employeeRecordApi";
import { EmployeeRecord } from "./model";

export type EmployeeRecordAction =
    ({ type: typeof actions.LOAD_EMPLOYEE_RECORDS_SUCCESS } & Payload<EmployeeRecord[]>);

export const loadEmployeeRecordsSuccess = (employeeRecord: EmployeeRecord[]) => ({
    payload: employeeRecord,
    type: actions.LOAD_EMPLOYEE_RECORDS_SUCCESS
});

export function loadEmployeeRecords({ employeeRecordIds }: { employeeRecordIds: string[] }) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_EMPLOYEE_RECORDS, employeeRecordApi.getAll(employeeRecordIds));
        dispatch(loadEmployeeRecordsSuccess(result));
    };
}
